import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// "คำถามที่พบบ่อย" — single-open accordion (open panel gets the brand-blue
// answer band), reusing the home-business FaqBiz pattern. Copy is i18n-keyed
// under services.new.faq.* (q1–q6, each with q/a).
const faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6']

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0 90px',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: { padding: '44px 0 60px' },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 40px',
    [theme.breakpoints.down('sm')]: { fontSize: 22, margin: '0 0 26px' },
  },
  list: { maxWidth: 860, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '16px' },
  item: { background: T.color.surface, borderRadius: 18, boxShadow: T.shadow.card, overflow: 'hidden' },
  itemOpen: { boxShadow: '0 12px 30px rgba(0,102,204,0.16)' },
  qBtn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '22px 26px',
    minHeight: 44,
    fontFamily: T.font.heading,
    fontSize: 18,
    fontWeight: 600,
    color: T.color.ink,
    [theme.breakpoints.down('sm')]: { padding: '18px 18px', fontSize: 15 },
  },
  chev: {
    flexShrink: 0,
    width: 34,
    height: 34,
    borderRadius: '50%',
    background: T.color.brand,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.3s ease',
    '& svg': { display: 'block' },
  },
  chevOpen: { transform: 'rotate(180deg)' },
  answerWrap: { display: 'grid', gridTemplateRows: '0fr', transition: 'grid-template-rows 0.32s ease' },
  answerWrapOpen: { gridTemplateRows: '1fr' },
  answerInner: { overflow: 'hidden' },
  answer: {
    background: T.gradient.blue,
    color: T.color.onBrand,
    fontFamily: T.font.body,
    fontSize: 15,
    lineHeight: 1.7,
    margin: '0 12px 12px',
    padding: '18px 22px',
    borderRadius: 14,
    [theme.breakpoints.down('sm')]: { fontSize: 14, margin: '0 10px 10px', padding: '16px 18px' },
  },
  '@media (prefers-reduced-motion: reduce)': {
    answerWrap: { transition: 'none' },
    chev: { transition: 'none' },
  },
}))

const ServiceFaq = () => {
  const classes = useStyles()
  const { t } = useTranslation('services')
  const [open, setOpen] = useState(0)
  return (
    <section className={classes.root} id="faq">
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>{t('new.faq.heading')}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className={classes.list}>
            {faqKeys.map((fk, i) => {
              const isOpen = open === i
              return (
                <div key={fk} className={`${classes.item} ${isOpen ? classes.itemOpen : ''}`}>
                  <button
                    type="button"
                    className={classes.qBtn}
                    aria-expanded={isOpen}
                    aria-controls={`svc-faq-panel-${i}`}
                    id={`svc-faq-btn-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    <span>{t(`new.faq.${fk}.q`)}</span>
                    <span className={`${classes.chev} ${isOpen ? classes.chevOpen : ''}`}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M4 6l4 4 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`${classes.answerWrap} ${isOpen ? classes.answerWrapOpen : ''}`}
                    id={`svc-faq-panel-${i}`}
                    role="region"
                    aria-labelledby={`svc-faq-btn-${i}`}
                  >
                    <div className={classes.answerInner}>
                      <p className={classes.answer}>{t(`new.faq.${fk}.a`)}</p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </Reveal>
      </Container>
    </section>
  )
}

export default ServiceFaq
